// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__I3WCy","select":"styles_select__1ModI"};